import { FETCH_PICTURE_DATA, DELETE_PICTURE } from '../actions/types';


export default (state = [], action) => {
    switch (action.type) {
        case FETCH_PICTURE_DATA:
            return  [...action.payload.resources];
        case DELETE_PICTURE:
            return state.filter(picture => picture.public_id !== action.payload);
        default:
            return state;
    }
};